import React from 'react';
import { getComponentClasses } from '../../utils/app';
import { IconType } from './IconType';

interface Props {
    type: IconType;
    variations?: string[];
    children?: React.ReactNode;
}

export default class Icon extends React.Component<Props> {
    render() {
        let variations: string[] = [];
        if (this.props.variations) {
            variations = [...this.props.variations, this.props.type];
        } else {
            variations = [this.props.type];
        }

        const classes = getComponentClasses('icon', variations);

        return <span className={classes}>{this.props.children}</span>;
    }
}
